import { ForbiddenError } from '..';
import { parseJwtToken } from './jwt_token';
import { invariant } from '@streem/toolbox';
const LOGIN_IDENTITY_KEY = 'custom:streem_login_identity_id';
export function getLoginIdentityFromToken(idToken) {
    const data = parseJwtToken(idToken);
    const loginIdentityId = data[LOGIN_IDENTITY_KEY];
    if (!loginIdentityId) {
        throw new ForbiddenError(`Could not get login identity id from token for subject: '${data.sub}'`);
    }
    invariant(data.email, 'idToken is expected to contain a user email');
    return {
        // rather than fetching access token from streem backend
        // accept the id from the FusionAuth provided token
        // platform endpoint will perform token validation
        id: loginIdentityId,
        avatarUrl: data.picture,
        name: data.name,
        email: data.email,
    };
}
//# sourceMappingURL=identified_user.js.map